<template>

  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader :title="$t('deposits.deposits')"
                     :description="$t('deposits.fromHereYouCanControlThedeposits')"/>
         <indexTable :searchText="$t('deposits.SearchForHonesty')"
                    :emptyTableText="$t('deposits.thereAreNodeposits')"
                    :emptyTableSubText="$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')"
                    :buttonRole="$user.role.deposits_add"
                    :cloumns="[
                     {column: 'owner_name',    title:$t('deposits.TheNameOfTheChequeHolder') ,type: 'mainLink' , sort: true },
                     {column: 'converter_name',  title:$t('deposits.Converter')  ,type: 'text'     , sort: true },
                     {column: 'converted_to', title:$t('deposits.Adapter')      ,type: 'text'     , sort: true},
                     {column: 'cost',    title:$t('deposits.cost')       ,type: 'text'     , sort: true },
                     {column: 'options', title:$t('endorsements.settings'), type: 'options', options: [
                         {name: 'show'},
                         {name: 'edit',   role: $user.admin || $user.role.deposits_edit},
                         {name: 'print',   role: true},
                         {name: 'delete', role: $user.admin || $user.role.deposits_delete},
                     ]}
                   ]"
                   :deleteText="{
                    attention: $t('allerts.Attention'),
                    areYouReallySureToDeleteTheItem: $t('allerts.areYouReallySureToDeleteTheItem'),
                    close: $t('allerts.close'),
                    confirm: $t('allerts.confirm'),
                    loading: $t('allerts.loading'),
                   }" />
      </div>
    </div>
    <print v-if="printInvoice"></print>
  </div>

</template>
<script>

  import indexHeader from '../elements/index/indexHeader.vue'
  import indexTable from '../elements/index/indexTable.vue'

  import print from './components/print.vue'

  export default {
    data() {
      return {
        path: '/deposits',
      }
    },
    components: {
      indexHeader,
      indexTable,
      print
    }
  }

</script>
